import { render, staticRenderFns } from "./ver_agendamento_cliente.vue?vue&type=template&id=a473dfc6&scoped=true"
import script from "./ver_agendamento_cliente.vue?vue&type=script&lang=js"
export * from "./ver_agendamento_cliente.vue?vue&type=script&lang=js"
import style0 from "./ver_agendamento_cliente.vue?vue&type=style&index=0&id=a473dfc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473dfc6",
  null
  
)

export default component.exports